import { connect } from 'react-redux';

import { IRootState } from '../../../state-mgmt/rootState';
import CreditCardDeclinedModal from './CreditCardDeclinedModal';
import { push } from 'connected-react-router';
import { clientState } from 'modules/state-mgmt/client';

export const mapStateToProps = (state: IRootState) => ({
  isFcaUser: state.auth?.isFcaUser,
  isAdmin: state.auth?.isAdmin,
  // isAuthenticated: state.auth?.authenticated,
  // companyUserId: state.auth?.companyUserId,
  // userId: state.user?.accountData?.id,
});

export const mapDispatchToProps = dispatch => ({
  navigate: (path: string) => dispatch(push(path)),
  viewFailedTransactions: () => dispatch(clientState.actions.viewFailedTransactions()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreditCardDeclinedModal);
